import { z } from 'zod';

export const AdjustmentSourceSchema = z.enum(['FILE_UPLOAD', 'API_BATCH', 'MATRIX_FORM']);
export type AdjustmentSource = z.infer<typeof AdjustmentSourceSchema>;

export const AdjustmentStateSchema = z.enum([
  'NEW',
  'AM_REVIEWED',
  'ACCEPTED',
  'REJECTED',
]);
export type AdjustmentState = z.infer<typeof AdjustmentStateSchema>;

export const ForecastAdjustmentSchema = z.object({
  id: z.string(),
  warehouse_id: z.string(),
  customer_id: z.string(),
  date: z.string(), // target date YYYY-MM-DD
  qty: z.number().int().nonnegative(),
  state: AdjustmentStateSchema.default('NEW'),
  source: AdjustmentSourceSchema,
  is_late: z.boolean().default(false),
  note: z.string().default(''),
  submitted_at: z.string(),
  submitted_by: z.string(),
});
export type ForecastAdjustment = z.infer<typeof ForecastAdjustmentSchema>;
